import { z } from 'zod';

import { GroupType } from './groups';

// Lean projection of the employee a Link recognizes (RecipientBlueprint).
export const ExternalRecognitionRecipient = z.object({
	id: z.string(),
	displayName: z.string().catch(''),
	profilePicUrl: z.string().nullable().catch(null),
	email: z.string().optional().catch(''),
});
export type ExternalRecognitionRecipient = z.infer<typeof ExternalRecognitionRecipient>;

// Admin serialization of a Link (LinkBlueprint). Field keys arrive camelized by
// OliveBranch because the query sends `Key-Inflection: camel`.
export const ExternalRecognitionLink = z.object({
	id: z.string(),
	publicToken: z.string().catch(''),
	name: z.string().catch(''),
	startDate: z.string().nullable().catch(null),
	endDate: z.string().nullable().catch(null),
	status: z.enum(['active', 'inactive']).catch('inactive'),
	message: z.string().nullable().catch(null),
	createdAt: z.string().catch(''),
	deletedAt: z.string().nullable().optional().catch(null),
	recipientSummary: z.string().nullable().optional().catch(null),
	submissionsCount: z.number().catch(0),
	recipient: ExternalRecognitionRecipient.nullable().optional().catch(null),
	recipientRulesGroup: z
		.object({
			id: z.string(),
			groupType: z.nativeEnum(GroupType),
			conditions: z.array(
				z.object({
					attr: z.string(),
					value: z.string(),
				})
			),
		})
		.nullable()
		.optional()
		.catch(null),
});
export type ExternalRecognitionLink = z.infer<typeof ExternalRecognitionLink>;

export const SubmissionState = z.enum(['posted', 'needs_approval', 'denied']);
export type SubmissionState = z.infer<typeof SubmissionState>;

// Admin serialization of a Submission (SubmissionBlueprint).
export const ExternalRecognitionSubmission = z.object({
	id: z.string(),
	name: z.string().nullable().catch(null),
	comment: z.string().nullable().catch(null),
	recipientSummary: z.string().nullable().optional().catch(null),
	state: SubmissionState.catch('needs_approval'),
	bonusId: z.string().nullable().catch(null),
	metaIpAddress: z.string().nullable().optional().catch(null),
	metaUserAgent: z.string().nullable().optional().catch(null),
	createdAt: z.string().catch(''),
});
export type ExternalRecognitionSubmission = z.infer<typeof ExternalRecognitionSubmission>;
